/**
 * Video Hero with Logo
 * Handles animated logo scaling on scroll
 */

(function() {
  // Find all video hero sections
  const sections = document.querySelectorAll('.vhl');
  
  sections.forEach(section => {
    // Get ALL logo elements (both desktop and mobile)
    const logos = section.querySelectorAll('.vhl__logo');
    const logoInner = section.querySelector('.vhl__logo-inner');
    const video = section.querySelector('.vhl__video');
    const header = document.querySelector('.site-header');
    
    // Get settings from data attributes
    const maxScale = logoInner ? parseFloat(logoInner.dataset.maxScale) || 4 : 4;
    const maxScaleMobile = logoInner ? parseFloat(logoInner.dataset.maxScaleMobile) || maxScale : maxScale;
    const animationSpeed = logoInner ? parseFloat(logoInner.dataset.animationSpeed) || 60 : 60;
    const animationSpeedMobile = logoInner ? parseFloat(logoInner.dataset.animationSpeedMobile) || animationSpeed : animationSpeed;
    const headerAppearScale = logoInner ? parseFloat(logoInner.dataset.headerAppearScale) || 1.15 : 1.15;
    const headerAppearScaleMobile = logoInner ? parseFloat(logoInner.dataset.headerAppearScaleMobile) || headerAppearScale : headerAppearScale;
    const logoFadeStart = logoInner ? parseFloat(logoInner.dataset.logoFadeStart) || 1.3 : 1.3;
    const logoFadeStartMobile = logoInner ? parseFloat(logoInner.dataset.logoFadeStartMobile) || logoFadeStart : logoFadeStart;
    const logoMaxOpacity = logoInner ? parseFloat(logoInner.dataset.logoOpacity) || 1 : 1;
    
    // Detect mobile
    const isMobile = () => window.innerWidth <= 767;
    
    // Keep video playing
    if (video) {
      const playVideo = () => {
        if (video.paused) {
          video.play().catch(() => {
            video.muted = true;
            video.play().catch(() => {});
          });
        }
      };
      
      playVideo();
      video.addEventListener('pause', () => setTimeout(playVideo, 100));
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden) playVideo();
      });
    }
    
    // Logo scroll animation - desktop only
    if (logos.length > 0 && logoInner) {
      let ticking = false;
      const disableMobileAnimation = logoInner.dataset.disableMobileAnimation === 'true';
      
      const updateLogo = () => {
        const scrollY = window.scrollY || window.pageYOffset;
        const sectionHeight = section.offsetHeight;
        const sectionTop = section.offsetTop;
        
        // Check if animation is disabled on mobile
        const mobile = isMobile();
        if (mobile && disableMobileAnimation) {
          // Use the mobile scale setting as fixed size (no animation)
          logos.forEach(logo => {
            logo.style.transform = `scale(${maxScaleMobile})`;
            logo.style.opacity = logoMaxOpacity;
          });
          
          // Still handle header appearance based on scroll
          const scrollY = window.scrollY || window.pageYOffset;
          const sectionHeight = section.offsetHeight;
          const sectionTop = section.offsetTop;
          const scrollEnd = sectionTop + sectionHeight * (animationSpeedMobile / 100);
          const progress = Math.min(1, Math.max(0, scrollY / scrollEnd));
          const scale = maxScaleMobile - (progress * (maxScaleMobile - 1));
          
          const headerEl = header?.headerSection || header;
          if (headerEl) {
            if (scale <= headerAppearScaleMobile) {
              headerEl.classList.remove('header-logo-scaling');
            } else {
              headerEl.classList.add('header-logo-scaling');
            }
          }
          return;
        }
        
        // Use mobile settings on mobile devices
        const currentMaxScale = mobile ? maxScaleMobile : maxScale;
        const currentAnimationSpeed = mobile ? animationSpeedMobile : animationSpeed;
        const currentHeaderAppearScale = mobile ? headerAppearScaleMobile : headerAppearScale;
        const currentLogoFadeStart = mobile ? logoFadeStartMobile : logoFadeStart;
        
        // Calculate scroll progress (0 to 1)
        const scrollEnd = sectionTop + sectionHeight * (currentAnimationSpeed / 100);
        const progress = Math.min(1, Math.max(0, scrollY / scrollEnd));
        
        // Scale goes from currentMaxScale down to 1
        const scale = currentMaxScale - (progress * (currentMaxScale - 1));
        
        // Apply transform to ALL logo elements
        logos.forEach(logo => {
          logo.style.transform = `scale(${scale})`;
          
          // Handle logo fade
          if (scale <= currentLogoFadeStart) {
            const fadeRange = currentLogoFadeStart - 1;
            const fadeProgress = (scale - 1) / fadeRange;
            const opacity = Math.max(0, Math.min(logoMaxOpacity, fadeProgress * logoMaxOpacity));
            logo.style.opacity = opacity;
          } else {
            logo.style.opacity = logoMaxOpacity;
          }
        });
        
        // Handle header appearance separately
        const headerEl = header?.headerSection || header;
        if (headerEl) {
          if (scale <= currentHeaderAppearScale) {
            headerEl.classList.remove('header-logo-scaling');
          } else {
            headerEl.classList.add('header-logo-scaling');
          }
        }
      };
      
      // Initial update
      updateLogo();
      
      // Scroll handler
      window.addEventListener('scroll', () => {
        if (!ticking) {
          window.requestAnimationFrame(() => {
            updateLogo();
            ticking = false;
          });
          ticking = true;
        }
      }, { passive: true });
      
      // Resize handler - also update on resize to handle orientation changes
      let resizeTimeout;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(updateLogo, 100);
      });
    }
  });
})();